export const CURRENCIES = [
  { code: 'USD', symbol: '$', label: 'USD ($)' },
  { code: 'EUR', symbol: '€', label: 'EUR (€)' },
  { code: 'GBP', symbol: '£', label: 'GBP (£)' },
  { code: 'CAD', symbol: 'C$', label: 'CAD (C$)' },
  { code: 'AUD', symbol: 'A$', label: 'AUD (A$)' },
  { code: 'JPY', symbol: '¥', label: 'JPY (¥)' },
];

export const DEFAULT_CURRENCY = 'USD';

export const SYMBOLS = {
  USD: '$',
  EUR: '€',
  GBP: '£',
  CAD: 'C$',
  AUD: 'A$',
  JPY: '¥',
};

export const getCurrency = () => {
  try {
    const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('bindarr_currency') : null;
    return (stored && SYMBOLS[stored]) ? stored : DEFAULT_CURRENCY;
  } catch {
    return DEFAULT_CURRENCY;
  }
};

export const setCurrency = (code) => {
  const next = SYMBOLS[code] ? code : DEFAULT_CURRENCY;
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('bindarr_currency', next);
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('bindarr_currency_change', { detail: next }));
  }
};

export const currencySymbol = (currency) => {
  const code = (currency && SYMBOLS[currency]) ? currency : getCurrency();
  return SYMBOLS[code] || '$';
};

export const activeCurrencySymbol = () => SYMBOLS[getCurrency()] || '$';

export const formatPrice = (p) => (parseFloat(p) || 0).toFixed(2);

// Provider prices are not converted. When a row names its source currency, show
// that currency's symbol instead of repainting EUR as the user's preferred '$'.
// Callers without row-level currency keep the active display currency.
export const priceText = (p, currency = null) =>
  `${currencySymbol(currency || getCurrency())}${formatPrice(p)}`;

// Missing market data is not a zero-dollar valuation. Totals and cost paid keep
// using priceText, where zero is a legitimate amount.
export const marketPriceText = (p, currency = null) =>
  Number(p) > 0 ? `${priceText(p, currency)} ${currency || getCurrency()}` : 'Price unavailable';
